export default {
  ERRORS: {
    ACCESS: {
      TITLE: 'Access denied',
      SUBTITLE: 'Reach out to your workspace admin to update your permissions and access this area.',
      RETURN: 'Back to dashboard',
    },
    ERROR: {
      TITLE: 'Something went wrong',
      SUBTITLE: 'We couldn\'t load this page. Please try again later.',
      RETURN: 'Back to dashboard',
    },
    NOT_FOUND: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      404: '404',
      TITLE: 'Page not found',
      SUBTITLE: 'We couldn\'t find what you\'re looking for.',
      FAQ: {
        TITLE: 'FAQ',
        SUBTITLE: 'Find answers to common questions.',
      },
      SOLUTION_CENTER: {
        TITLE: 'Help Center',
        SUBTITLE: 'Browse articles and tutorials.',
      },
      PERMISSION_MANAGER: {
        TITLE: 'Roles & Permissions',
        SUBTITLE: 'Learn how workspace access works.',
      },
    },
    OFFER_NOT_FOUND: {
      TITLE: 'This job is no longer available.',
      CLOSED_MESSAGE: 'The company has closed this job post.',
      DISCOVER_MESSAGE: 'Discover new opportunities and keep applying through the wokap app.',
      DOWNLOAD_APP: 'Download the app',
      VIEW_OTHER_OFFERS: 'View other job offers',
    },
  },
} as const;
